import React from 'react';

export default function ApiClientItemShowSecretModal(props) {
    return (
        <div className="modal fade" id="api-client-secret-modal" tabIndex="-1" role="dialog" aria-labelledby="api-client-secret-modal" aria-hidden="true">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{$t('App Secret')}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.onClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group row">
                            <label htmlFor="inputName" className="col-sm-12 my-auto text-sm">
                                {$t('Please store this secret somewhere secure. After clicking "Close" it will not be displayed again')}
                                <br />
                                {props.secret}
                            </label>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="button secondary" onClick={props.onClose}>
                            {$t('Close')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
